export default __webpack_public_path__ + "static/media/icn_to_wht.228271dc.svg";